import Remove from '@mui/icons-material/Remove';
import { ToggleButton } from '@mui/material';
import { AlignmentButtons, ClearButtons, ColorButtons, DefaultEditorOptions, FormatButtons, LevelSelect, ListButtons, QuoteButtons, RichTextInput, RichTextInputProps, RichTextInputToolbar, RichTextInputToolbarProps, useTiptapEditor } from 'ra-input-rich-text';
import ImageFmButton from './RichTextInputEx/ImageFmButton';
import InsertMergeFieldButton from './RichTextInputEx/InsertMergeFieldButton';
import LinkFmButton from './RichTextInputEx/LinkFmButton';
import LinkLinkButton from './RichTextInputEx/LinkLinkButton';
import './RichTextInputEx/RichTextInputEx.scss';

interface MyRichTextInputToolbarProps extends RichTextInputToolbarProps {
  mode?: "title" | "email"
}

const MyRichTextInputToolbar = ({ size, mode, ...props }: MyRichTextInputToolbarProps) => {
  const editor = useTiptapEditor();

  return (
    <RichTextInputToolbar {...props}>
      <LevelSelect size={size} />
      <FormatButtons size={size} />
      <AlignmentButtons size={size} />
      <ListButtons size={size} />
      <ColorButtons size={size} />

      {/* <LinkButtons size={size} /> */}
      {"email" === mode && <LinkFmButton size={size} />}
      {"email" === mode && <LinkLinkButton size={size} />}

      {/* <ImageButtons size={size} /> */}
      {"email" === mode && <ImageFmButton size={size} />}

      <QuoteButtons size={size} />
      <ClearButtons size={size} />

      {"email" === mode && <ToggleButton size={size}
        aria-label="Add an horizontal rule"
        title="Add an horizontal rule"
        value="left"
        onClick={() =>
          editor.chain().focus().setHorizontalRule().run()
        }
        selected={editor && editor.isActive('horizontalRule')}
      >
        <Remove fontSize="inherit" />
      </ToggleButton>}
      {"email" === mode && <InsertMergeFieldButton size={size} fields={[
        { value: '{%FIRST_NAME%}', caption: 'First Name' },
        { value: '{%LAST_NAME%}', caption: 'Last Name' },

        { value: '{%VERIFICATION_TOKEN%}', caption: 'Verify Link Token' },
        { value: '{%FORGOT_PASSWORD_TOKEN%}', caption: 'Forgot Password Link Token' },

        { value: '{%USERNAME%}', caption: 'Username' },
        { value: '{%EMAIL%}', caption: 'Email' },
        { value: '{%PASSWORD%}', caption: 'Password' },
        //
        { value: '{%INVOICE%}', caption: 'Invoice No.' },
        { value: '{%AMOUNT%}', caption: 'Amount' },
        { value: '{%METHOD%}', caption: 'Payment Method' },
        { value: '{%TRANSACTION_STATUS%}', caption: 'Transaction Status' },
        //
        { value: '{%QUESTION%}', caption: 'Question' },
        //
        { value: '{%MESSAGE%}', caption: 'Opinion Message' },
        //
        { value: '{%IDENTITY%}', caption: 'Volenteer Sign Up - Indentity ' },
        //
        { value: '{%VOLUNTEER_NUMBER%}', caption: 'Volenteer No.' },
      ]}></InsertMergeFieldButton>}
    </RichTextInputToolbar>
  );
}

export const MyEditorOptions = {
  ...DefaultEditorOptions,
  extensions: [
    ...DefaultEditorOptions.extensions,
    // HorizontalRule,
  ],
};

interface RichTextInputExProps extends RichTextInputProps {
  mode?: "title" | "email"
}
const RichTextInputEx = ({ ...props }: RichTextInputExProps) => {
  return (
    <RichTextInput
      fullWidth={true}
      editorOptions={MyEditorOptions}
      toolbar={<MyRichTextInputToolbar size={"small"} mode={props.mode} />}
      sx={{
        "& .ra-input": {
          height: '200px',
        },
        "& .RaRichTextInput-editorContent": {
          height: '120px',
        }
      }}
      {...props}
    />
  );
}

export default RichTextInputEx;
